import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Radio
} from 'antd';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setFilter } from '../../../actions';

import styles from './StatSwitch.module.css';

class StatSwitch extends PureComponent {
  render() {
    const {
      filters,
      handleType,
    } = this.props;

    const content = (
      !!filters && filters.typeOfStatistics ? (
        <div className={styles['container']}>
          <Radio.Group
            value={filters.typeOfStatistics}
            buttonStyle="solid"
            className={styles['buttons-group']}
          >
            <Radio.Button
              value="est"
              onClick={() => handleType('est')}
              className={styles.button}
            >
              {filters.tabkey === 'requests' ? 'Total' : 'Estimated'}
            </Radio.Button>
            <Radio.Button
              value="ver"
              onClick={() => handleType('ver')}
              className={styles.button}
            >
              {filters.tabkey === 'requests' ? 'Non-empty' : 'Verified'}
            </Radio.Button>
          </Radio.Group>
        </div>
      ) : null
    );

    return content;
  }
}

StatSwitch.propTypes = {
  filters: PropTypes.object.isRequired,
  handleType: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  filters: state.filters.filters,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setFilter,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(StatSwitch);
